// noinspection JSValidateTypes

import DateTime from './DateTime.js';
import UTCDateRange from './UTCDateRange.js';

export default class DateTimeRange extends UTCDateRange {
  static get ThisMinute() {
    return this.this('minute');
  }

  static get LastMinute() {
    return this.range(this._current.subtract(1, 'minute'), 'minute');
  }

  static get NextMinute() {
    return this.range(this._current.add(1, 'minute'), 'minute');
  }

  static get ThisHour() {
    return this.this('hour');
  }

  static get LastHour() {
    return this.range(this._current.subtract(1, 'hour'), 'hour');
  }

  static get NextHour() {
    return this.range(this._current.add(1, 'hour'), 'hour');
  }

  static get Today() {
    return this.range(this._current, 'day');
  }

  static get Yesterday() {
    return this.range(this._current.subtract(1, 'day'), 'day');
  }

  static get Tomorrow() {
    return this.range(this._current.add(1, 'day'), 'day');
  }

  static get _current() {
    return DateTime.now;
  }

  static _validateUnit(unit) {
    if (!['minute', 'hour', 'day', 'week', 'month', 'year'].includes(unit)) {
      throw new Error(`invalid unit ${unit}`);
    }
  }

  static _create(value) {
    return value instanceof DateTime ? value : new DateTime(value);
  }
}
